module.exports = __webpack_public_path__ + "img/home-services-01.7475a517.webp";